// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:slug*?\",\"regex\":\"^/(.*)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/account/purchases/:id\",\"regex\":\"^/account/purchases/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/buy/:slug*\",\"regex\":\"^/buy/(.+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/product-detail/:sku\",\"regex\":\"^/product-detail/([^/]+)$\",\"paramNames\":[\"sku\"],\"hasOptionalPrefix\":false},{\"path\":\"/product-detail/:sku/similar\",\"regex\":\"^/product-detail/([^/]+)/similar$\",\"paramNames\":[\"sku\"],\"hasOptionalPrefix\":false},{\"path\":\"/street-smarts/:page*?\",\"regex\":\"^/street-smarts(?:/(.*))?$\",\"paramNames\":[\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/street-smarts/content/:slug\",\"regex\":\"^/street-smarts/content/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/used-cars/:filter\",\"regex\":\"^/used-cars/([^/]+)$\",\"paramNames\":[\"filter\"],\"hasOptionalPrefix\":false},{\"path\":\"/used-cars/:filter/:sort\",\"regex\":\"^/used-cars/([^/]+)/([^/]+)$\",\"paramNames\":[\"filter\",\"sort\"],\"hasOptionalPrefix\":false},{\"path\":\"/used-cars/:filter/:sort/:page\",\"regex\":\"^/used-cars/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"filter\",\"sort\",\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/watchlist/:page\",\"regex\":\"^/watchlist/([^/]+)$\",\"paramNames\":[\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/car-match/:treePath\",\"regex\":\"^/car-match/([^/]+)$\",\"paramNames\":[\"treePath\"],\"hasOptionalPrefix\":false},{\"path\":\"/car-match/:treePath/results\",\"regex\":\"^/car-match/([^/]+)/results$\",\"paramNames\":[\"treePath\"],\"hasOptionalPrefix\":false},{\"path\":\"/finance-application/:uuid\",\"regex\":\"^/finance-application/([^/]+)$\",\"paramNames\":[\"uuid\"],\"hasOptionalPrefix\":false},{\"path\":\"/forms/auth/new-password/:token\",\"regex\":\"^/forms/auth/new-password/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/investors/:slug*?\",\"regex\":\"^/investors(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/investors/announcements/:sort\",\"regex\":\"^/investors/announcements/([^/]+)$\",\"paramNames\":[\"sort\"],\"hasOptionalPrefix\":false},{\"path\":\"/investors/announcements/:sort/:page\",\"regex\":\"^/investors/announcements/([^/]+)/([^/]+)$\",\"paramNames\":[\"sort\",\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/offer/:id\",\"regex\":\"^/offer/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/product-compare/:sku1/:sku2\",\"regex\":\"^/product-compare/([^/]+)/([^/]+)$\",\"paramNames\":[\"sku1\",\"sku2\"],\"hasOptionalPrefix\":false},{\"path\":\"/product-compare/:sku1/:sku2/:differences\",\"regex\":\"^/product-compare/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"sku1\",\"sku2\",\"differences\"],\"hasOptionalPrefix\":false},{\"path\":\"/product-detail/:sku/get-started\",\"regex\":\"^/product-detail/([^/]+)/get-started$\",\"paramNames\":[\"sku\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/account/finance-quotes\"},{\"path\":\"/account/notifications\"},{\"path\":\"/account/personal\"},{\"path\":\"/account/purchases\"},{\"path\":\"/error-auth\"},{\"path\":\"/sitemap-page\"},{\"path\":\"/subscribe\"},{\"path\":\"/unsubscribed\"},{\"path\":\"/used-cars\"},{\"path\":\"/watchlist-unsubscribe\"},{\"path\":\"/active-campaign/football-comp\"},{\"path\":\"/car-match\"},{\"path\":\"/car-match/visualiser\"},{\"path\":\"/component-preview\"},{\"path\":\"/forms/auth/phone-verify\"},{\"path\":\"/forms/auth/user-info\"},{\"path\":\"/forms/auth/create\"},{\"path\":\"/forms/auth/create-success\"},{\"path\":\"/forms/auth/password\"},{\"path\":\"/forms/auth/reset-password\"},{\"path\":\"/forms/auth/reset-password-verification\"},{\"path\":\"/forms/auth/start\"},{\"path\":\"/forms/booking\"},{\"path\":\"/forms/booking/cancelled\"},{\"path\":\"/forms/booking/company\"},{\"path\":\"/forms/booking/confirm\"},{\"path\":\"/forms/booking/end\"},{\"path\":\"/forms/booking/location\"},{\"path\":\"/forms/booking/time\"},{\"path\":\"/forms/checkout\"},{\"path\":\"/forms/personalised-quote\"},{\"path\":\"/forms/trade-in-enquiry\"},{\"path\":\"/forms/trade-in-enquiry/accident-details\"},{\"path\":\"/forms/trade-in-enquiry/basic-info\"},{\"path\":\"/forms/trade-in-enquiry/car-history\"},{\"path\":\"/forms/trade-in-enquiry/digital-screen\"},{\"path\":\"/forms/trade-in-enquiry/edit-car\"},{\"path\":\"/forms/trade-in-enquiry/expected-valuation\"},{\"path\":\"/forms/trade-in-enquiry/exterior\"},{\"path\":\"/forms/trade-in-enquiry/exterior-damage\"},{\"path\":\"/forms/trade-in-enquiry/factory-options\"},{\"path\":\"/forms/trade-in-enquiry/hail\"},{\"path\":\"/forms/trade-in-enquiry/interior\"},{\"path\":\"/forms/trade-in-enquiry/interior-damage\"},{\"path\":\"/forms/trade-in-enquiry/intro\"},{\"path\":\"/forms/trade-in-enquiry/mechanical\"},{\"path\":\"/forms/trade-in-enquiry/mechanical-issues\"},{\"path\":\"/forms/trade-in-enquiry/missed-anything\"},{\"path\":\"/forms/trade-in-enquiry/modifications\"},{\"path\":\"/forms/trade-in-enquiry/odours\"},{\"path\":\"/forms/trade-in-enquiry/other-fields\"},{\"path\":\"/forms/trade-in-enquiry/personal-info\"},{\"path\":\"/forms/trade-in-enquiry/photos\"},{\"path\":\"/forms/trade-in-enquiry/rego-state\"},{\"path\":\"/forms/trade-in-enquiry/rips-tears\"},{\"path\":\"/forms/trade-in-enquiry/service-history\"},{\"path\":\"/forms/trade-in-enquiry/stains\"},{\"path\":\"/forms/trade-in-enquiry/timeline\"},{\"path\":\"/forms/trade-in-enquiry/tyre\"},{\"path\":\"/forms/trade-in-enquiry/vehicle-confirmation\"},{\"path\":\"/forms/trade-in-enquiry/wheel-damage\"},{\"path\":\"/forms/trade-in-enquiry/windscreen-damage\"},{\"path\":\"/forms/trade-in-enquiry/car-found\"},{\"path\":\"/forms/trade-in-enquiry/car-not-found\"},{\"path\":\"/forms/trade-in-enquiry/continue\"},{\"path\":\"/forms/trade-in-enquiry/end\"},{\"path\":\"/helper-modal-preview\"},{\"path\":\"/investors/announcements\"},{\"path\":\"/magic\"}],\"isrRoutes\":[\"/:slug*?\",\"/buy/:slug*\",\"/product-detail/:sku\",\"/product-detail/:sku/similar\",\"/street-smarts/content/:slug\",\"/used-cars/:filter\",\"/investors/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.1.1";import * as Sentry from '@sentry/nextjs';
import { getSampleRate } from 'sentry.helpers';

const config: Sentry.BrowserOptions = {
  dsn: 'https://b83c872be5e73227b80d9231e110ff1f@o4506080610353152.ingest.us.sentry.io/4506096634167296',

  environment: process.env.SENTRY_ENVIRONMENT,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampler: (samplingContext) => {
    const { attributes } = samplingContext;
    // Check if URL contains /forms and set 100% sampling rate
    if (
      (typeof attributes?.path === 'string' && attributes.path.includes('/forms')) ||
      (typeof window !== 'undefined' && window.location.href.includes('/forms'))
    ) {
      return 1.0;
    }

    return getSampleRate(0.02);
  },
  // Profiling sample rate is relative to tracesSampleRate
  profilesSampleRate: 1.0,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  // Only enable Sentry on CloudRun
  enabled: process.env.STANDALONE === 'true',

  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,
  integrations: [],

  beforeSend: (event, hint) => {
    const error = hint.originalException;
    // Filter out hard navigate errors from NextJS
    // https://sentry.io/answers/handle-hard-navigation-errors-in-nextjs/
    if (event.exception?.values?.[0].value?.includes('Invariant: attempted to hard navigate to the same URL')) {
      return null;
    }

    // Check for the specific error type and message
    if (
      error &&
      typeof error === 'object' &&
      'name' in error &&
      'message' in error &&
      error.name === 'TypeError' &&
      error.message === 'Load failed'
    ) {
      return null;
    }

    return event;
  },

  // See https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/filtering/#decluttering-sentry
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // Ignore fetch errors, most of them happen due to slow network
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'Network Error',
    // Facebook iOS autofill not properly implemented
    '_AutofillCallbackHandler',
    // Hubspot tracking
    '_hsq',
    // React internal error thrown when something outside react modifies the DOM
    // This is usually because of a browser extension or Chrome's built-in translate
    "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
    "NotFoundError: Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
    // Block CSP error from tracking scripts
    "Blocked unsafe (eval() or inline) 'script'",
    "Blocked 'script' from 'inline:'",
    "Blocked 'script' from 'eval:'",
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i,
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Ignore Google flakiness
    /\/(gtm|ga|analytics)\.js/i,
    // Ignore LiveChat network errors
    /\/tracking\.js/i,
    // Ignore Google One-tap errors
    /gsi\/client/i,
    // Ignore Google tag manager errors
    /gtag\/js/i,
    // Ignore Recaptcha errors
    /recaptcha__en/i,
    // Ignore Userberry errors
    /useberryScript/i,
    // Ignore maze.co errors
    /contextualScaffold/i,
    // Ignore bing errors
    /bat\.bing\.com/i,
  ],
};

Sentry.init({
  ...config,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: [process.env.SENTRY_APPLICATION_KEY ?? ''],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
